<!-- Este componente carga el layout de la ruta y aquí debe de estar toda la parte visual independiente de layout, pej un footer... -->
<template>
    <div id="root-component">
        <!-- Botón de pantalla completa 
        <button v-if="isSupported" @click="toggleFullscreen"
            :aria-label="isFullscreen ? $t('shared.ui.buttons.exitFullscreen') : $t('shared.ui.buttons.enterFullscreen')"
            class="title-bar-button"
            :title="isFullscreen ? $t('shared.ui.buttons.exitFullscreen') : $t('shared.ui.buttons.enterFullscreen')">
            <i v-if="!isFullscreen" class="fa-solid fa-expand" aria-hidden="true"></i>
            <i v-else class="fa-solid fa-compress" aria-hidden="true"></i>
        </button>-->
        <Component :is="$route.meta.layout || 'div'">
            <RouterView></RouterView>
        </Component>
        <footer>
            <!-- Este span hay que dejarlo en algún sitio donde no moleste. Sirve para mostrar en depuración el id del tab
        -->
            <span v-if="id" class="d-none">
                IdTab: {{ id }}
            </span>
        </footer>
    </div>

</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";
import { RouterView } from "vue-router";
import { useI18n } from 'vue-i18n';
import { useFullscreen } from "@services/fullscreen-service";

const { t } = useI18n();
const id = ref<string | null>(null);

if (import.meta.env.VITE_IS_DEBUG === "true") {
    id.value = (window as any)["instance_id"];
}

// Configurar pantalla completa para el elemento raíz
const rootElement = ref<HTMLElement | null>(null);
const { isFullscreen, isSupported, toggleFullscreen, setTarget } = useFullscreen(null);

onMounted(() => {
    // Establecer el elemento raíz como objetivo
    const element = document.getElementById('root-component');
    if (element) {
        rootElement.value = element;
        setTarget(element);
    }
});
</script>

<style scoped lang="scss">
.title-bar-button {
    background: transparent;
    border: 0;
    font-size: 24px;
    padding: var(--spacing-xs, 8px) var(--spacing-md, 16px);
    width: auto;
    display: flex;

    i {
        color: var(--text-default-caption, #667790);
    }

}
</style>